import { WorkflowPhase } from '@atlas/types'
import { type StatusTone, WorkOrderStageCard } from '@atlas/ui-kit'
import { initials } from '@/lib/labels'

export interface StageRailProps {
	stage: { label: string; phase: WorkflowPhase | null }
	designerName: string | null
	pmName: string | null
}

/**
 * A status's colour by its phase, as the kit's Status maps the screens' statuses: intake as the
 * initial check, production in progress, validation, and delivery as done. Statuses are workflow
 * data, so the phase, not the code, picks the tone.
 */
const PHASE_TONE: Record<WorkflowPhase, StatusTone> = {
	[WorkflowPhase.INTAKE]: 'warning',
	[WorkflowPhase.PRODUCTION]: 'accent',
	[WorkflowPhase.VALIDATION]: 'purple',
	[WorkflowPhase.DELIVERY]: 'success',
}

const personOf = (name: string | null) => (name ? { name, initials: initials(name) } : null)

/** Where the order stands and who is on it. */
export function StageRail({ stage, designerName, pmName }: StageRailProps) {
	return (
		<aside aria-label="Order status and people">
			<WorkOrderStageCard
				status={{ label: stage.label, tone: stage.phase ? PHASE_TONE[stage.phase] : 'neutral' }}
				assignees={[
					{ role: 'Designer', person: personOf(designerName) },
					{ role: 'PM', person: personOf(pmName) },
				]}
			/>
		</aside>
	)
}
